import { TranslatePipe } from '@myre/ui-primitive-core';

import { Component } from '@angular/core';

import {
  ModalSectionKey,
  type ModalHeaderData,
} from '../../../modal.interface';

import { ModalSectionComponent } from '../abstract/modal-section.component';

@Component({
  selector: 'myre-modal-header-default',
  templateUrl: './app-modal-header-default.component.html',
  styleUrls: ['./app-modal-header-default.component.scss'],
  imports: [TranslatePipe],
})
export class DefaultHeaderComponent extends ModalSectionComponent<ModalHeaderData> {
  protected _name = ModalSectionKey.Header;
}
